import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { UserProfile } from "@/lib/storage";

interface Props {
  profile: UserProfile;
  onChange: (profile: UserProfile) => void;
}

const QUESTIONS = [
  { key: 'salary', label: 'What are your salary expectations?' },
  { key: 'noticePeriod', label: 'What is your notice period?' },
  { key: 'challenge', label: 'Describe a challenge you overcame' },
];

export default function CommonQuestionsStep({ profile, onChange }: Props) {
  const updateAnswer = (key: string, value: string) => {
    onChange({ ...profile, commonAnswers: { ...profile.commonAnswers, [key]: value } });
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-display font-bold text-lg text-foreground">Common Questions</h2>
        <p className="text-sm text-muted-foreground mt-1">Pre-fill answers to speed up applications.</p>
      </div>
      <div className="space-y-4">
        {QUESTIONS.map(q => (
          <div key={q.key}>
            <Label className="text-xs font-medium text-muted-foreground">{q.label}</Label>
            <Textarea
              placeholder="Your answer..."
              value={profile.commonAnswers[q.key] || ''}
              onChange={e => updateAnswer(q.key, e.target.value)}
              className="mt-1 min-h-[60px]"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
